export default __webpack_public_path__ + "static/clean-pan-47a38aa14c25dda40c8327fe036ce861.webp";